import React, { useContext } from 'react';
import styles from './ZavrsniRadoviFilterMenu.module.css';
import { ThemeContext } from '../contexts/ThemeContext';

const ZavrsniRadoviFilterMenu = ({ 
    showRadoviFilterMenu, 
    setSelectedCiklus, 
    setSelectedStatus,
    /*selectedCiklus,*/
    selectedStatus }) => {
  const { dark } = useContext(ThemeContext);

  /*const ciklusOnChangeHandler = (e) => {
    setSelectedCiklus(e.target.value);
  }*/

  const statusRadaOnChangeHandler = (e) => {
    setSelectedStatus(e.target.value);
  }

  return (
    <>
      {showRadoviFilterMenu ? (
        <div className={dark ? styles.filterMenuContainerDark : styles.filterMenuContainerLight}>

          {/*<div className={styles.filterOptionContainer}>
            <div className={dark ? styles.filterOptionHeaderDark : styles.filterOptionHeaderLight}>
              Ciklus
            </div>
            <div className={styles.filterOptionItem}>

              <input
                id="ciklus-svi"
                type="radio"
                value="Svi"
                name="ciklus"
                checked={selectedCiklus === "Svi"}
                onChange={e => ciklusOnChangeHandler(e)} /><label htmlFor="ciklus-svi">Svi</label>
              <input
                id="ciklus-prvi"
                type="radio"
                value="Prvi"
                name="ciklus"
                checked={selectedCiklus === "Prvi"}
                onChange={e => ciklusOnChangeHandler(e)} /> <label htmlFor="ciklus-prvi">Prvi</label>
              <input
                id="ciklus-drugi"
                type="radio"
                value="Drugi"
                name="ciklus"
                checked={selectedCiklus === "Drugi"}
                onChange={e => ciklusOnChangeHandler(e)} /> <label htmlFor="ciklus-drugi">Drugi</label>
            </div>
      </div>*/}
          <div className={styles.filterOptionContainer}>
            <div className={dark ? styles.filterOptionHeaderDark : styles.filterOptionHeaderLight}>
              Status rada
            </div>
            <div className={styles.filterOptionItem}>
              <input
                id="status-svi"
                type="radio"
                value="Svi"
                name="statusRada"
                checked={selectedStatus === "Svi"}
                onChange={e => statusRadaOnChangeHandler(e)} /> <label htmlFor="status-svi">Svi</label>
              <input
                id="status-slobodan"
                type="radio"
                value="Slobodan"
                name="statusRada"
                checked={selectedStatus === "Slobodan"}
                onChange={e => statusRadaOnChangeHandler(e)} /> <label htmlFor="status-slobodan">Slobodan</label>
              <input
                id="status-zauzet"
                type="radio"
                value="Zauzet"
                name="statusRada"
                checked={selectedStatus === "Zauzet"}
                onChange={e => statusRadaOnChangeHandler(e)} /> <label htmlFor="status-zauzet">Zauzet</label>
              <input
                id="status-odbranjen"
                type="radio"
                value="Odbranjen"
                name="statusRada"
                checked={selectedStatus === "Odbranjen"}
                onChange={e => statusRadaOnChangeHandler(e)} /> <label htmlFor="status-odbranjen">Odbranjen</label>
            </div>
          </div>
        </div>) : (
          null
        )}
    </>
  );
}

export default ZavrsniRadoviFilterMenu;